import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='description-box'>
        <div className="navigator">
            <div className="nav-box">Description</div>
            <div className="nav-box fade">Reviews (122)</div>
        </div>
        <div className="description">
            <p>An e-commerce website is an online platform that facilitates the buying and selling of products or services over the internet. It serves as a virtual marketplace where business and individuals can showcase their products, interact with customers and conduct transactions without the need for a physical presence. E-commerce websites have gained immense popularity due to their convinience, accessibility and the global reach they offer.</p>
            <p>e-commerce websites typically display products or services along with detailed descriptions, images, prices and any available variations (e.g. sizes, colors). Each product usually has its own dedicated page with relevant information.</p>
        </div>
    </div>
  )
}

export default DescriptionBox